// extracted by mini-css-extract-plugin
export default {"marketNewsHeader":"header_marketNewsHeader__qZTBG","wrapper":"header_wrapper__FMWzm","content":"header_content__LwbOB","search":"header_search__V8d+W"};